<template>
  <div class="page-container">
    <div class="header">
      <div class="title">费用明细</div>
    </div>
    <div class="search-form">
      <el-form
        class="search-form-content"
        inline
        :model="form"
        label-width="100px"
        label-position="left">
        <el-row>
          <el-col>
            <el-form-item label="创建时间" size="small">
              <div class="time-range-content">
                <div class="quick-time-picker">
                  <div
                    :class="['item', {active: activeIndex === item.value}, {disabled: disabledItem(item)}]"
                    v-for="(item, index) in timeQuickPickerList"
                    :key="index"
                    @click="handleQuickTimePickerChange(item.value)"
                  >{{ item.label }}
                  </div>
                </div>
                <el-date-picker
                  v-model="dateTimeRange"
                  :picker-options="pickerOptions"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  @change="handleTimeRangeChange"
                  align="right"
                  size="small"/>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" v-for="(item, index) in formItemList1" :key="index + '1'">
            <el-form-item :label="item.itemLabel" size="small">
              <CommonSelect
                v-model="form[item.value]"
                :needAll="true"
                :options="optionsObj[item.options]"
                :isMultiple="item.isMultiple"
                :needPaging="item.needPaging"
                :pageLoading="item.pageLoading"
                :filterable="item.filterable || false"
                :clearable="item.clearable || false"
                @change="item.change"
                @loadmore="handleLoadMore(item.query)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商户号" size="small">
              <el-input v-model="form.shopMerchantId" placeholder="请输入乐刷商户号" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-for="(item, index) in formItemList2" :key="index + '2'">
            <el-form-item :label="item.itemLabel" size="small">
              <CommonSelect
                v-model="form[item.value]"
                :needAll="true"
                :options="optionsObj[item.options]"
                :isMultiple="item.isMultiple"
                :needPaging="item.needPaging"
                :pageLoading="item.pageLoading"
                :filterable="item.filterable || false"
                :clearable="item.clearable || false"
                @change="item.change"
                @loadmore="handleLoadMore(item.query)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交易订单号" size="small">
              <el-input v-model="form.orderId" placeholder="请输入交易单号"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="min-width: 330px;" :span="8" :offset="16">
            <el-form-item size="small">
              <el-button type="primary" @click="handleFormSearch" class="bs-btn">查询</el-button>
              <el-button type="primary" class="bs-btn" :loading="exportLoading" @click="exportTable()">导出查询结果
              </el-button>
              <el-button @click="handleFormReset" class="bs-btn2">重置</el-button>
              <el-button type="primary" @click="handleSetTableHead" class="bs-btn">设置表头</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="middle-container">
      <div v-for="(item, index) in middleItems" :key="index" class="middle-wrap">
        <div v-if="item.sign" class="middle-item">
          <span class="symbol"/>
          <span v-if="item.sign === 'equal'" class="value symbol">=</span>
          <span v-else :class="`value ${item.sign} symbol`"/>
        </div>
        <div class="middle-item">
          <span>
            {{ item.label }}
            <el-tooltip v-if="item.tip" :content="item.tip" placement="top">
              <i class="el-icon-question"/>
            </el-tooltip>
          </span>
          <span class="value">{{ divide100(item.value || summaryData[item.prop]) }}</span>
        </div>
      </div>
    </div>
    <div class="tips-container">
      <p>温馨提示</p>
      <p>1、失败状态、预授权、预授权撤销的交易不涉及费用计算；</p>
      <p>2、仅支持查询{{ isSortMerchant ? '今' : '昨' }}天及以前的费用明细，每次查询时间跨度不超过32天；</p>
      <p>3、单次导出记录上限为100万条，若超过100万条，将导出失败，请注意控制查询及导出数量；</p>
    </div>
    <div class="table-container">
      <el-table :data="table.data" style="width: 100%;" border v-loading="table.loading">
        <el-table-column prop="orderId" label="交易订单号" align="center" min-width="150px">
          <template slot-scope="{row}">{{ row.type === 1 ? row.orderId : row.transactionId }}</template>
        </el-table-column>
        <el-table-column prop="orderCreateTime" label="交易创建时间" align="center" min-width="160px"/>
        <el-table-column prop="successTime" label="交易完成时间" align="center" min-width="160px"/>
        <el-table-column prop="amount" label="交易金额(元)" align="center" min-width="120px">
          <template slot-scope="{row}">{{ zeroNegative((divide100(row.amount)), 'amount', isNegativeTrans(row.transType)) }}</template>
        </el-table-column>
        <el-table-column prop="realMerchantCommissionAmount" label="订单总扣费(元)" align="center" min-width="120px">
          <template slot-scope="{row}">{{ zeroNegative(divide100(row.realMerchantCommissionAmount), 'realMerchantCommissionAmount', isNegativeTrans(row.transType)) }}</template>
        </el-table-column>
        <el-table-column prop="realMerchantSettlementAmount" label="应结金额(元)" align="center" min-width="120px">
          <template slot-scope="{row}">{{ zeroNegative(divide100(row.realMerchantSettlementAmount), 'realMerchantSettlementAmount', isNegativeTrans(row.transType)) }}</template>
        </el-table-column>
        <el-table-column prop="settleStatus" label="费用计算状态" align="center" min-width="150px">
          <template slot-scope="{row}">{{ parseValueToChinese(row.settleStatus, 'settleStatusOptions') }}</template>
        </el-table-column>
        <el-table-column prop="receiveScene" label="收款场景" align="center" min-width="80px">
          <template slot-scope="{row}">{{ parseValueToChinese(row.receiveScene, 'receiveScenesOptions') }}</template>
        </el-table-column>
        <el-table-column prop="payType" label="交易方式" align="center" min-width="80px">
          <template slot-scope="{row}">{{ parseValueToChinese(row.payType, 'payTypesOptions') }}</template>
        </el-table-column>
        <el-table-column prop="transType" label="交易类型" align="center" min-width="80px">
          <template slot-scope="{row}">{{ parseValueToChinese(row.transType, 'transTypesOptions') }}</template>
        </el-table-column>
        <el-table-column prop="royalty" label="交易标记" align="center" min-width="80px">
          <template slot-scope="{row}">{{ parseValueToChinese(row.royalty, 'royaltyOptions') }}</template>
        </el-table-column>
        <el-table-column prop="realSettleType" label="结算类型" align="center" min-width="80px">
          <template slot-scope="{row}">{{ parseValueToChinese(row.realSettleType, 'settlementTypeOptions') }}</template>
        </el-table-column>
        <el-table-column prop="deviceStr" label="收款设备" align="center" min-width="150px"/>
        <el-table-column prop="cashierAreaNoStr" label="收银点" align="center" min-width="120px"/>
        <el-table-column prop="shopStr" label="门店" align="center" min-width="180px"/>
        <el-table-column label="操作" align="center" fixed="right" min-width="120px">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleTableView(row)">费用详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-content">
        <el-pagination
          v-if="table.totalCount > 0"
          :page-size="table.pageSize"
          :layout="layout"
          :total="table.totalCount"
          :current-page="table.pageNo"
          @current-change="onChangeCurrentPage"/>
      </div>
    </div>
    <el-dialog title="费用详情" :visible.sync="showDetailDialog" width="1200px">
      <el-form inline :model="detailForm" style="width: 100%;" label-width="150px">
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="交易订单号：">
              <div class="detail-form-row">
                <span id="businessNo">{{ detailForm.orderId || '-' }}</span>
                <copy-btn id="#businessNo"/>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交易流水号：">
              <div class="detail-form-row">
                <span id="businessSerialNo">{{ detailForm.transactionId || '-' }}</span>
                <copy-btn v-if="detailForm.transactionId" id="#businessSerialNo"/>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="费用计算时间：">
              <div class="detail-form-row">
                <span>{{ detailForm.settleCreateTime || '-' }}</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户简称：">
              <span>{{ detailForm.merchantName || '-' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="商户号：">
              <span>{{ detailForm.merchantId || '-' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交易状态：">
              <span>{{ parseValueToChinese(detailForm.transStatus, 'transStatusOptions') || '-' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="结算类型：">
              <span>{{ parseValueToChinese(detailForm.realSettleType, 'settlementTypeOptions') || '-' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交易金额（元）：">
              <span>{{ divide100(detailForm.amount) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item>
              <span slot="label">
                应结金额(元)
                <el-tooltip content="应结金额=交易金额-订单总扣费" placement="top">
                  <i class="el-icon-question"/>
                </el-tooltip>：
              </span>
              <span>{{ divide100(detailForm.realMerchantSettlementAmount) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="门店类型：">
              <span>{{ mapShopType[detailForm.shopType] || '-' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="设备类型：">
              <span>{{ detailForm.deviceType | deviceTypeFilter }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卡类型：">
              <span>{{ detailForm.cardType | cardTypeFilter }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="24">
            <el-form-item label="备注：">
              <span>{{ detailForm.attach || '-' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="dialog-table-tips">
        <span slot="label">
          订单总扣费(元)
          <el-tooltip placement="top">
            <template slot="content">
              <p>订单总扣费=基础手续费+单笔加收费+分账手续费+花呗商家贴息+银联分期费+其他费用。</p>
            </template>
            <i class="el-icon-question"/>
          </el-tooltip>
          ：{{ zeroNegative(divide100(detailForm.realMerchantCommissionAmount), 'realMerchantCommissionAmount', isNegativeTrans(detailForm.transType)) }}
        </span>
      </div>
      <el-table :data="detailTable.data" style="width: 100%;" border v-loading="detailTable.loading">
        <el-table-column prop="feeRate" label="基础手续费率" align="center" min-width="120px">
          <template slot-scope="{row}">{{ row.feeRate ? `${row.feeRate}%`: row.feeRate }}</template>
        </el-table-column>
        <el-table-column prop="baseFee" label="基础手续费（元）" align="center" min-width="150px" :formatter="handleBaseFee">
          <template slot="header">
            基础手续费(元)
            <el-tooltip content="自2021年10月12号起，刷卡借记卡交易固定优惠0.04%的手续费，该基础手续费已为优惠后费用。" placement="top">
              <i class="el-icon-question"/>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="unionDisCountFee" label="银联降费（元）" align="center" min-width="150px"/>
        <el-table-column prop="singleAddFee" label="单笔加收费（元）" align="center" min-width="150px"/>
        <el-table-column prop="huaBeiFee" label="花呗商家贴息（元）" align="center" min-width="150px"/>
        <el-table-column prop="unionFee" label="银联分期费（元）" align="center" min-width="150px"/>
        <el-table-column prop="subFee" label="分账手续费" align="center" min-width="100px"/>
        <el-table-column prop="otherFee" label="其他费用" align="center" min-width="80px"/>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button class="bs-btn" type="primary" @click="showDetailDialog = false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog center class="head-set-dialog" title="表头设置" :visible.sync="showSetTableHeadDialog" width="1200px" :close-on-click-modal="false">
      <div class="title">温馨提示</div>
      <div class="tip">点击勾选表头，在导出数据查询结果时，可根据相应勾选的表头及点击表头的先后顺序(先勾选先展示)，导出数据结果</div>
      <div class="head-box">
        <div class="row">
          <div
            v-for="item in selectedHeadList"
            :class="{btn:true, active: item.selected}"
            :key="item.name"
            @click="doCheckedDetailHeader(item)">
            <span>{{ item.headerName }}</span>
            <div class="mark"><i class="el-icon-check"/></div>
          </div>
        </div>
      </div>
      <div style="text-align: right;">
        <span @click="restoreHeadSet" class="dialog-btn" size="mini">恢复默认表头设置</span>
      </div>
      <div class="head-box no-select">
        <div class="row">
          <div
            v-for="item in unSelectedHeadList"
            :class="{btn:true}"
            :key="item.name"
            @click="doCheckedDetailHeader(item)">
            <span>{{ item.headerName }}</span>
            <div class="mark"><i class="el-icon-check"/></div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button class="bs-btn2" type="primary" @click="showSetTableHeadDialog = false">取消</el-button>
        <el-button class="bs-btn" type="primary" @click="handleTableHeadSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable object-curly-newline */
import moment from "moment";
import copyBtn from '../../components/CopyBtn/copy-btn.vue';
import CommonSelect from '@/components/CommonSelect.vue';
import { v160Mixins } from "@/mixins/mixinsv160";
import {
  queryShopList,
  queryCashierList,
  queryDeviceList,
} from "@/api/flow";
import {
  queryCostList,
  queryCostDetail,
  exportCostDetail,
  getMerchantType,
  getFieldConfig,
  setFieldConfig,
} from "@/api/expense-details";
import {
  debounce,
  sToFixed,
} from "@/utils/index";

const FORMAT_YMD = 'yyyy-MM-DD';
const FORMAT_YM = 'yyyy-MM';
const today = moment().format(FORMAT_YMD);
const yesterday = moment().subtract(1, "days").format(FORMAT_YMD);
const startTime = '00:00:00';
const endTime = '23:59:59';

export default {
  name: 'expense-details',
  mixins: [v160Mixins],
  components: {
    copyBtn,
    CommonSelect,
  },
  data() {
    const that = this;
    return {
      activeIndex: 0,
      dateTimeRange: [],
      pickerOptions: {
        disabledDate(time) {
          return time > moment(that.defaultTime[1]).valueOf() || time < moment('2022-08-01').valueOf();
        },
      },
      optionsObj: {
        receiveScenesOptions: [
          { label: '普通收款', value: 0 },
          { label: '收款单', value: 1 },
          { label: '扫码点餐', value: 2 },
        ], // 收款场景
        payTypesOptions: [
          { label: '银行卡', value: 1 },
          { label: '微信', value: 2 },
          { label: '支付宝', value: 3 },
          { label: '银联云闪付', value: 4 }, // 原银联二维码
          { label: '数字人民币', value: 5 },
          { label: '银行卡预授权', value: 6 },
          { label: '支付宝预授权', value: 7 },
          { label: '微信预授权', value: 8 },
        ], // 交易方式
        transTypesOptions: [
          { label: '收款', value: 1 },
          { label: '退款', value: 2 },
          { label: '撤销', value: 3 },
          { label: '冲正', value: 4 },
          { label: '预授权', value: 5 },
          { label: '预授权完成', value: 6 },
          { label: '预授权撤销', value: 7 },
          { label: '预授权完成撤销（退款）', value: 8 },
        ], // 交易类型
        settlementTypeOptions: [
          { label: 'D1结算', value: 1 },
          { label: 'D0结算', value: 0 },
        ], // 结算类型
        settleStatusOptions: [
          { label: '处理中', value: 1 },
          { label: '成功', value: 2 },
          { label: '失败', value: 3 },
        ], // 费用计算状态
        transStatusOptions: [
          { label: '成功', value: 1 },
          { label: '失败', value: 2 },
          { label: '处理中', value: 3 },
        ], // 交易状态
        shopOptions: [], // 门店
        cashierOptions: [], // 收银点
        royaltyOptions: [
          { label: '普通交易', value: 0 },
          { label: '分账', value: 1 },
          { label: '其他', value: 2 },
          { label: '普通交易', value: 3 },
        ], // 交易标记
        deviceOptions: [], // 收款设备
      },
      form: {
        receiveScenes: ['all'],
        payTypes: ['all'],
        transTypes: ['all'],
        settleStatus: ['all'],
        shopIds: ['all'],
        deviceIds: "",
        cashierAreaNos: '',
        orderId: "",
        shopMerchantId: "",
      },
      summaryData: {
        settleAmountSum: 0,
        payAmountSum: 0,
        refundAmountSum: 0,
        payFeeAmountSum: 0,
        refundFeeAmountSum: 0,
      },
      table: {
        loading: false,
        data: [],
        pageNo: 1,
        totalCount: 0,
        pageSize: 10,
      },
      showDetailDialog: false,
      detailForm: {},
      detailTable: {
        loading: false,
        data: [],
      },
      exportLoading: false,
      shopType: 1,
      formItemList1: [
        {
          itemLabel: '收款场景',
          value: 'receiveScenes',
          options: 'receiveScenesOptions',
          isMultiple: true,
        },
        {
          itemLabel: '交易方式',
          value: 'payTypes',
          options: 'payTypesOptions',
          isMultiple: true,
        },
        {
          itemLabel: '交易类型',
          value: 'transTypes',
          options: 'transTypesOptions',
          isMultiple: true,
        },
        {
          itemLabel: '费用计算状态',
          value: 'settleStatus',
          options: 'settleStatusOptions',
          isMultiple: true,
        },
      ],
      formItemList2: [
        {
          itemLabel: '门店',
          value: 'shopIds',
          options: 'shopOptions',
          isMultiple: true,
          change: this.handleShopChange,
          needPaging: true, // 门店列表需要分页
          pageLoading: false,
          pageNo: 1,
          pageSize: 30,
          finished: false,
          query: 'queryMerchantShopList',
        },
        {
          itemLabel: '收银点',
          value: 'cashierAreaNos',
          options: 'cashierOptions',
          change: this.handleCashierChange,
          filterable: true,
          clearable: true,
        },
        {
          itemLabel: '收款设备',
          value: 'deviceIds',
          options: 'deviceOptions',
          filterable: true,
          clearable: true,
        },
      ],
      // 枚举
      mapShopType: {
        0: '分店',
        1: '总店',
      },
      middleItems: [
        { label: '交易应结金额(元)', prop: 'settleAmountSum' },
        // 没有prop说明后端没有返回字段，需要前端计算给value赋值
        { sign: 'equal', label: '营业收入(元)', value: '', tip: '仅统计乐刷清算订单' },
        { sign: 'subtract', label: '总扣费(元)', value: '' },
        { sign: 'equal', label: '收款交易金额(元)', prop: 'payAmountSum' },
        { sign: 'subtract', label: '退款交易金额(元)', prop: 'refundAmountSum' },
        { sign: 'subtract', label: '收款订单总扣费(元)', prop: 'payFeeAmountSum' },
        { sign: 'add', label: '退款订单总扣费(元)', prop: 'refundFeeAmountSum', tip: '退款交易，会按退款比例退回交易手续费' },
      ],
      isSortMerchant: false, // 当前用户是否是实时清分
      showSetTableHeadDialog: false,
      tableHeadList: [],
    };
  },
  filters: {
    deviceTypeFilter(val) {
      const obj = {
        [-1]: '未知',
        1: '码牌',
        2: 'PC插件',
        3: '商户端APP',
        4: 'POS',
      };
      return obj[val] || '-';
    },
    cardTypeFilter(val) {
      const obj = {
        // 0: '未知',
        1: '借记卡',
        2: '贷记卡',
      };
      return obj[val] || '其他';
    },
  },
  computed: {
    selectedHeadList() {
      return this.tableHeadList.filter(item => item.selected);
    },
    unSelectedHeadList() {
      return this.tableHeadList.filter(item => !item.selected);
    },
    loginInfo() {
      const info = localStorage.getItem('LOGIN_INFO');
      return info ? JSON.parse(info) : {};
    },
    exportTable() {
      return debounce(this.exportTableFunc, 500, true);
    },
    layout() {
      const layout = 'total, prev, pager, next, jumper';
      return this.table.totalCount > 9999 ? 'total, prev, next' : layout;
    },
    isTheFirstDayOfMonth() {
      /**
       * 本月第一天
       * */
      return moment().date() === 1;
    },
    isTheFirstDayOfWeek() {
      /**
       * 本周第一天
       * */
      return moment().day() === 1;
    },
    isNegativeTrans() { // 判断是否是负向交易
      const negativeTransTypeList = [2, 3, 4, 7, 8];
      return transType => (negativeTransTypeList.includes(transType));
    },
    timeQuickPickerList() {
      const arr = [
        { label: '昨天', value: 0 },
        { label: '今天', value: 1 },
        { label: '本周', value: 2 },
        { label: '本月', value: 3 },
      ];
      return this.isSortMerchant ? arr.filter(i => i.value !== 0) : arr.filter(i => i.value !== 1);
    },
    defaultTime() {
      const yesterdayArr = [`${yesterday} ${startTime}`, `${yesterday} ${endTime}`];
      const todayArr = [`${today} ${startTime}`, `${today} ${endTime}`];
      return this.isSortMerchant ? todayArr : yesterdayArr;
    },
    defaultIndex() {
      return this.isSortMerchant ? 1 : 0;
    },
  },
  mounted() {
    if (this.loginInfo) this.shopType = this.loginInfo.shopType;
    this.initData();
  },
  methods: {
    async handleSetTableHead() {
      const { data: { code, data } } = await getFieldConfig({ default: false });
      if (code === '0') {
        this.showSetTableHeadDialog = true;
        this.tableHeadList = data;
        this.tableHeadList.sort((a, b) => a.order - b.order);
      }
    },
    async handleTableHeadSave() {
      if (!this.selectedHeadList.length) {
        this.$message.warning('表头不能为空');
      } else {
        const selectedList = [...this.selectedHeadList];
        const items = selectedList.map((item, index) => ({
          ...item,
          order: index,
        }));
        const { data: { code } } = await setFieldConfig({ items });
        if (code === '0') {
          this.showSetTableHeadDialog = false;
          this.$message.success('设置成功');
        }
      }
    },
    restoreHeadSet() {
      this.$confirm('恢复表头至默认状态，则展示全部的表头及表头的初始顺序。你确定要将当前设置的表头状态恢复至默认状态吗？', '恢复默认表头设置', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'bs-btn2',
        confirmButtonClass: 'bs-btn',
      }).then(async () => {
        const { data: { code, data } } = await getFieldConfig({ default: true });
        if (code === '0') {
          this.tableHeadList = data;
          this.tableHeadList.sort((a, b) => a.order - b.order);
        }
      }).catch(() => {});
    },
    doCheckedDetailHeader(item) {
      item.selected = !item.selected;
      const preIndex = this.tableHeadList.findIndex(i => i.name === item.name);
      this.tableHeadList.splice(preIndex, 1);
      this.tableHeadList.push(item);
    },
    sToFixed,
    disabledItem({ value }) {
      if (this.isSortMerchant) return false;
      return (value === 0 && this.isTheFirstDayOfWeek) || (value === 2 && this.isTheFirstDayOfMonth);
    },
    handleBaseFee({ baseFee, maxFeeFlag }) {
      return `${baseFee}${maxFeeFlag ? '（已封顶）' : ''}`;
    },
    async initData() {
      await this.getMerchantSettleType();
      this.dateTimeRange = this.defaultTime;
      this.activeIndex = this.defaultIndex;
      this.queryMerchantShopList();
      this.queryMerchantCashierList();
      this.queryMerchantDeviceList();
      this.queryTableData();
    },
    async getMerchantSettleType() {
      const { data: { code, data } } = await getMerchantType();
      if (code === '0') this.isSortMerchant = data;
    },
    handleLoadMore(queryFunc) {
      if (queryFunc) this[queryFunc]();
    },
    queryMerchantShopList() {
      const shop = this.formItemList2.find(v => v.itemLabel === '门店');
      const { pageNo, finished, pageSize } = shop;
      if (finished) return false;
      shop.pageLoading = true;
      queryShopList({ pageNo, pageSize }).then(({ data: { code, data, msg } }) => {
        shop.pageLoading = false;
        if (code === '0') {
          const newList = data.list.map(i => ({ label: `${i.shopName} ${i.shopId}`, value: i.shopId }));
          this.optionsObj.shopOptions = [...this.optionsObj.shopOptions, ...newList];
          if (newList.length < pageSize) {
            shop.finished = true;
          } else {
            shop.pageNo += 1;
          }
        }
      });
      return true;
    },
    queryMerchantCashierList() {
      this.form.cashierAreaNos = '';
      const { shopIds } = this.form;
      const params = { shopIds: shopIds.filter(i => i !== 'all') };
      queryCashierList(params).then(({ data: { code, data, msg } }) => {
        if (code === '0') {
          this.optionsObj.cashierOptions = data.map(i => ({
            label: `${i.cashierAreaName} ${i.cashierAreaNo}`,
            value: i.cashierAreaNo,
          }));
        }
      });
    },
    queryMerchantDeviceList() {
      this.form.deviceIds = '';
      const { shopIds, cashierAreaNos } = this.form;
      const params = {
        shopIds: shopIds.filter(i => i !== 'all'),
        cashierAreaNos: cashierAreaNos ? [cashierAreaNos] : [],
      };
      queryDeviceList(params).then(({ data: { code, data, msg } }) => {
        if (code === '0') {
          this.optionsObj.deviceOptions = data.map(i => ({
            label: `${i.deviceName} ${i.deviceId}`,
            value: i.deviceId,
          }));
        }
      });
    },
    handleQuickTimePickerChange(value) {
      let starTimeRange = '';
      let endTimeRange = '';
      if (!this.isSortMerchant) {
        if (value === 2 && this.isTheFirstDayOfWeek) return;
        if (value === 3 && this.isTheFirstDayOfMonth) return;
        endTimeRange = yesterday;
      } else {
        endTimeRange = today;
      }
      this.activeIndex = value;
      if (value === 0) {
        starTimeRange = yesterday;
      } else if (value === 1) {
        starTimeRange = today;
      } else if (value === 2) {
        const dayOfToday = moment().day();
        starTimeRange = moment().subtract(dayOfToday - 1, 'day').format(FORMAT_YMD);
      } else if (value === 3) {
        const currentMonth = moment().format(FORMAT_YM);
        starTimeRange = moment(currentMonth).format(FORMAT_YMD);
      }
      this.dateTimeRange = [`${starTimeRange} ${startTime}`, `${endTimeRange} ${endTime}`];
      this.handleFormSearch();
    },
    handleTimeRangeChange(time) {
      const [start, end] = time || [];
      if (moment(end).valueOf() - moment(start).valueOf() > 32 * 24 * 3600 * 1000) {
        this.dateTimeRange = [];
        return this.$message.warning('选择时间跨度不可超过32天');
      }
      this.activeIndex = null;
      return true;
    },
    handleShopChange() {
      this.queryMerchantCashierList();
      this.queryMerchantDeviceList();
    },
    handleCashierChange() {
      this.queryMerchantDeviceList();
    },
    handleFormSearch() {
      this.table.pageNo = 1;
      this.queryTableData();
    },
    handleFormReset() {
      this.form = {
        receiveScenes: ['all'],
        payTypes: ['all'],
        transTypes: ['all'],
        settleStatus: ['all'],
        shopIds: ['all'],
        deviceIds: "",
        cashierAreaNos: '',
        orderId: "",
        shopMerchantId: "",
      };
      this.dateTimeRange = this.defaultTime;
      this.activeIndex = this.defaultIndex;
      this.queryMerchantCashierList();
      this.handleFormSearch();
    },
    handleSetParams(callback) {
      const [startTime, endTime] = this.dateTimeRange || [];
      const { merchantId } = this.loginInfo;
      if (!startTime || !endTime) {
        this.$message.warning('请选择时间');
        return;
      }
      const {
        receiveScenes,
        payTypes,
        transTypes,
        settleStatus,
        shopIds,
        cashierAreaNos,
        deviceIds,
        orderId,
        shopMerchantId,
      } = this.form;
      const params = {
        receiveScenes: receiveScenes.filter(i => i !== 'all'),
        payTypes: payTypes.filter(i => i !== 'all'),
        transTypes: transTypes.filter(i => i !== 'all'),
        settleStatus: settleStatus.filter(i => i !== 'all'),
        shopIds: shopIds.filter(i => i !== 'all'),
        deviceIds: deviceIds ? [deviceIds] : [],
        cashierAreaNos: cashierAreaNos ? [cashierAreaNos] : [],
        orderId,
        startTime,
        endTime,
        merchantId,
        shopMerchantId,
      };
      callback(params);
    },
    queryTableData() {
      const { pageNo, pageSize } = this.table;
      this.handleSetParams((params) => {
        this.table.loading = true;
        queryCostList({ ...params, pageNo, pageSize }).then((res) => {
          const { data: { code, data: { summary = {}, pages = {} }, msg } } = res;
          this.table.loading = false;
          if (code === '0') {
            this.summaryData = summary;
            const { payAmountSum, refundAmountSum, payFeeAmountSum, refundFeeAmountSum } = this.summaryData;
            this.middleItems[1].value = payAmountSum - refundAmountSum;
            this.middleItems[2].value = payFeeAmountSum - refundFeeAmountSum;
            this.table.data = pages.list;
            this.table.totalCount = pages.totalCount;
          } else {
            this.errorResult();
          }
        }).catch(() => {
          this.errorResult();
          this.table.loading = false;
        });
      });
    },
    errorResult() {
      this.summaryData = {
        settleAmountSum: 0,
        payAmountSum: 0,
        refundAmountSum: 0,
        payFeeAmountSum: 0,
        refundFeeAmountSum: 0,
      };
      this.table.data = [];
      this.table.totalCount = 0;
    },
    /**
     * 改变当前页事件
     * @param  {number} pageNo 当前页码
     */
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
    parseValueToChinese(val, options) {
      const option = this.optionsObj[options].find(i => i.value === val);
      return option ? option.label : '-';
    },
    exportTableFunc() {
      this.handleSetParams((params) => {
        this.exportLoading = true;
        exportCostDetail(params).then(({ data: { code, msg } }) => {
          this.exportLoading = false;
          if (code === '0') {
            this.$message.success('导出成功，请到下载中心下载报表文件！');
          }
        });
      });
    },
    // 查看详情
    handleTableView({ transactionId, orderCreateTime, type, transType }) {
      const params = {
        orderId: transactionId,
        transCreateTime: orderCreateTime,
      };
      queryCostDetail(params).then((res) => {
        const { data: { code, data } } = res;
        if (code === '0') {
          this.detailForm = { ...data, type, transType };
          const {
            feeRate, baseFee, singleAddFee, subFee, huaBeiFee, unionFee, otherFee, unionDisCountFee, maxFeeFlag,
          } = data;
          this.detailTable.data = [
            {
              feeRate: this.divide100(feeRate),
              baseFee: this.divide100(baseFee),
              singleAddFee: this.divide100(singleAddFee),
              subFee: this.divide100(subFee),
              huaBeiFee: this.divide100(huaBeiFee),
              unionFee: this.divide100(unionFee),
              otherFee: this.divide100(otherFee),
              unionDisCountFee: this.divide100(unionDisCountFee),
              maxFeeFlag,
            },
          ];
          Object.keys(this.detailTable.data[0]).forEach((key) => { // 0加负号逻辑
            if (!['feeRate', 'maxFeeFlag'].includes(key)) {
              this.detailTable.data[0][key] = this.zeroNegative(this.detailTable.data[0][key], key, this.isNegativeTrans(transType));
            }
          });
          this.showDetailDialog = true;
        }
      });
    },
    divide100(val) {
      return (val / 100 || 0).toFixed(2);
    },
    zeroNegative(val, name, isRefund) {
      if (Number(val) !== 0) return val;
      const positiveList = [ // 在正向交易0需要不展示为负
        'amount', // 交易金额
        'realMerchantSettlementAmount', // 应结金额
        'unionDisCountFee', // 银联降费
      ];
      const negativeCondition = ((!isRefund && !positiveList.includes(name)) || (isRefund && positiveList.includes(name)));
      return negativeCondition ? `-${val}` : val;
    },
  },
};
</script>
<style lang="scss" scoped>
.blue {
  color: #008cff;
}

.orange {
  color: #ff9c00 !important;
}

.page-container {
  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search-form {
    padding: 40px 50px 20px;
    border-bottom: 20px solid #eee;

    .search-form-content {
      /deep/ .el-select,
      /deep/ .el-input {
        width: 210px;
      }
    }

    .time-range-content {
      display: flex;

      .quick-time-picker {
        display: flex;

        .item {
          flex: 1;
          width: 100px;
          min-width: 100px;
          height: 32px;
          margin-right: 14px;
          font-size: 14px;
          line-height: 32px;
          color: #5e5e63;
          text-align: center;
          cursor: pointer;
          border: 1px solid #dde0e7;

          &.active {
            color: #008cff;
            border: 1px solid #008cff;
          }

          &.disabled {
            cursor: no-drop;
            opacity: 0.5;
          }
        }
      }
    }
  }

  .middle-container {
    display: flex;
    padding: 20px 50px;
    background: #fff;
    border-bottom: 20px solid #eee;

    .middle-wrap {
      display: flex;
    }

    .middle-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      span {
        box-sizing: content-box;
        display: inline-block;
        min-height: 40px;
        padding: 0 10px;
        line-height: 40px;
        text-align: center;

        &.symbol {
          width: 20px;
        }

        &.value {
          font-size: 24px;
          font-weight: bold;
          color: #008cff;
        }
      }
    }
  }

  .tips-container {
    padding: 40px 50px 0;

    p {
      font-size: 18px;
      font-weight: 500;
      line-height: 27px;
      color: #27364d;

      &:not(:first-child) {
        font-size: 14px;
        color: #a6a6ae;
      }
    }
  }

  .table-container {
    padding: 40px 50px 0;
    background: #fff;

    .refund {
      color: #ff9c00 !important;
    }

    .pagination-content {
      margin-top: 10px;
      text-align: center;
    }
  }

  .detail-form-row {
    display: flex;
    justify-content: space-between;
  }

  .dialog-footer {
    text-align: center;
  }

  .el-dialog {
    .el-form-item {
      display: flex;
      width: 100%;

      /deep/ .el-form-item__content {
        flex: 1;
      }
    }
  }

  .dialog-table-tips {
    padding: 20px 0;
  }
}

// 加减号样式
.subtract,
.add {
  position: relative;

  &::after {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 16px;
    height: 4px;
    content: "";
    background-color: #008cff;
    transform: translate(-50%, -50%);
  }
}

.add {
  &::before {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 4px;
    height: 16px;
    content: "";
    background-color: #008cff;
    transform: translate(-50%, -50%);
  }
}

.head-set-dialog {
  .title {
    font-size: 20px;
  }

  .tip {
    margin: 15px 0;
    color: #b9b9b9;
  }

  .head-box {
    min-height: 110px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 10px;

    .row {
      display: flex;
      flex-wrap: wrap;

      .btn {
        position: relative;
        width: 130px;
        height: 32px;
        margin-right: 10px;
        margin-bottom: 10px;
        line-height: 32px;
        color: #666;
        text-align: center;
        cursor: pointer;
        border: 1px solid #dde0e7;
        border-radius: 2px;

        &.active {
          color: #008cff;
          border: 1px solid #008cff;

          .mark {
            border-right-color: #008cff;
            border-bottom-color: #008cff;
          }
        }

        .mark {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 0;
          height: 0;
          border: 12px solid #dfdfdf;
          border-top-color: transparent;
          border-left-color: transparent;

          i {
            position: absolute;
            font-size: 8px;
            color: #fff;
          }
        }
      }
    }
  }

  .no-select {
    min-height: 0;
    border: none;
  }

  .dialog-btn {
    display: inline-block;
    margin: 10px 0;
    color: #1395ff;
    cursor: pointer;
  }
}
</style>
